var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-bubble-wrapper", class: _vm.iconClassName },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showBubble,
              expression: "showBubble"
            }
          ],
          staticClass: "product-bubble warehouse-icon-bubble",
          on: {
            mouseover: function($event) {
              _vm.handleMouseOver()
            },
            mouseleave: function($event) {
              _vm.handleMouseLeave()
            }
          }
        },
        [_vm._v(_vm._s(_vm.warehouseName))]
      ),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-responsive",
        class: _vm.imageClassName,
        attrs: { src: _vm.iconImage },
        on: {
          mouseover: function($event) {
            _vm.handleMouseOver()
          },
          mouseleave: function($event) {
            _vm.handleMouseLeave()
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f023e38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f023e38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/WarehouseIcon.vue
// module id = null
// module chunks = 